import { defineStore } from '#q-app'
import { createPinia } from 'pinia'

// Importing all the stores alphabetically
import useAgentStore from './agent/index.js'
import useAnalyticsAdminStore from './analyticsAdmin/index.js'
import useAssignmentsStore from './assignments/index.js'
import useAuthStore from './auth/index.js'
import useCalendarStore from './calendar/index.js'
import useCampaignsStore from './campaigns/index.js'
import useCatalogsStore from './catalogs/index.js'
import useControlTowerStore from './controlTower/index.js'
import useDashboardStore from './dashboard/index.js'
import useExhibitionsStore from './exhibitions/index.js'
import useFilesStore from './files/index.js'
import useFoldersStore from './folders/index.js'
import useFormsStore from './forms/index.js'
import useFranchisesStore from './franchises/index.js'
import useGeneralReportPdfExportsStore from './generalReportPdfExports/index.js'
import useGeolocationStore from './geolocation/index.js'
import useGlobalStore from './global/index.js'
import useHierarchiesStore from './hierarchies/index.js'
import useIncidencesStore from './incidences/index.js'
import useLicensesStore from './licenses/index.js'
import useLocationsStore from './locations/index.js'
import useNotificationsStore from './notifications/index.js'
import useNotificationsCenterStore from './notificationsCenter/index.js'
import useOccurrencesStore from './occurrences/index.js'
import useOrganizationStore from './organization/index.js'
import usePhotosGalleryStore from './photosGallery/index.js'
import usePermissionsStore from './permissions/index.js'
import usePowerBiExportsStore from './powerBiExports/index.js'
import usePowerBiReportsStore from './powerBiReports/index.js'
import useQuickChecksStore from './quickChecks/index.js'
import useReportsStore from './reports/index.js'
import useRolesStore from './roles/index.js'
import useRoutinesStore from './routines/index.js'
import useSettingsStore from './settings/index.js'
import useSprintsStore from './sprints/index.js'
import useTasksStore from './tasks/index.js'
import useTimezonesStore from './timezones/index.js'
import useUsersStore from './users/index.js'
import useWidgetsStore from './widgets/index.js'
import useNoticesStore from './notices/index.js'
import useHomeConfigurationStore from './homeConfiguration/index.js'
import useSurveysStore from './surveys/index.js'

// Exporting all the stores for easy access (Put them in alphabetical order)
export {
  useAgentStore,
  useAnalyticsAdminStore,
  useAssignmentsStore,
  useAuthStore,
  useCalendarStore,
  useCampaignsStore,
  useCatalogsStore,
  useControlTowerStore,
  useDashboardStore,
  useExhibitionsStore,
  useFilesStore,
  useFoldersStore,
  useFormsStore,
  useFranchisesStore,
  useGeneralReportPdfExportsStore,
  useGeolocationStore,
  useGlobalStore,
  useHierarchiesStore,
  useIncidencesStore,
  useLicensesStore,
  useLocationsStore,
  useNotificationsStore,
  useNotificationsCenterStore,
  useOccurrencesStore,
  useOrganizationStore,
  usePhotosGalleryStore,
  usePermissionsStore,
  usePowerBiExportsStore,
  usePowerBiReportsStore,
  useQuickChecksStore,
  useReportsStore,
  useRolesStore,
  useRoutinesStore,
  useSettingsStore,
  useSprintsStore,
  useTasksStore,
  useTimezonesStore,
  useUsersStore,
  useWidgetsStore,
  useNoticesStore,
  useHomeConfigurationStore,
  useSurveysStore
}

// Utility function to get all store instances (excluding global to avoid recursion)
export const getAllStoresForReset = () => {
  return [
    useAgentStore,
    useAnalyticsAdminStore,
    useAssignmentsStore,
    useAuthStore,
    useCalendarStore,
    useCampaignsStore,
    useCatalogsStore,
    useControlTowerStore,
    useDashboardStore,
    useExhibitionsStore,
    useFilesStore,
    useFoldersStore,
    useFormsStore,
    useFranchisesStore,
    useGeneralReportPdfExportsStore,
    useGeolocationStore,
    useHierarchiesStore,
    useIncidencesStore,
    useLicensesStore,
    useLocationsStore,
    useNotificationsStore,
    useNotificationsCenterStore,
    useOccurrencesStore,
    useOrganizationStore,
    usePhotosGalleryStore,
    usePermissionsStore,
    usePowerBiExportsStore,
    usePowerBiReportsStore,
    useQuickChecksStore,
    useReportsStore,
    useRolesStore,
    useRoutinesStore,
    useSettingsStore,
    useSprintsStore,
    useTasksStore,
    useTimezonesStore,
    useUsersStore,
    useWidgetsStore,
    useNoticesStore,
    useHomeConfigurationStore,
    useSurveysStore
  ]
}

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */

export default defineStore((/* { ssrContext } */) => {
  const pinia = createPinia()

  return pinia
})
